import React from "react";
import PropTypes from "prop-types";

import styles from "./style.module.scss";

const SortableHeading = ({
  onClick,
  column,
  style,
  label,
  orderDirection,
  orderColumn,
}) => {
  return (
    <th
      onClick={() => onClick(column)}
      className={styles.sortable}
      style={style}
    >
      <span>
        {label}
        <i
          className={`icon icon-chevron-${
            orderDirection === "ASC" ? "down" : "up"
          }`}
          style={{
            visibility: orderColumn === column ? "visible" : "hidden",
          }}
        />
      </span>
    </th>
  );
};

SortableHeading.propTypes = {
  onClick: PropTypes.func.isRequired,
  column: PropTypes.number.isRequired,
  style: PropTypes.shape({}),
  label: PropTypes.string.isRequired,
  orderDirection: PropTypes.oneOf(["ASC", "DESC"]).isRequired,
  orderColumn: PropTypes.number.isRequired,
};

SortableHeading.defaultProps = {
  style: {},
};

export default SortableHeading;
